// extracted by mini-css-extract-plugin
module.exports = {"message":"BankingInfo_message_I63WK","section":"BankingInfo_section_30fel","form":"BankingInfo_form_3p47I","row":"BankingInfo_row_nS3Nq","input":"BankingInfo_input_2c2lY"};